
<v-footer
    class="footer"
    color="primary"
    height="auto"
>
  <v-row align="center" class="footerContent" justify="center">
    <v-col cols="12" md="3">
      <v-row class="links" justify="center">
        <v-btn
            text
            to="/imprint"
        >
          {{ $t("IMPRINT_LINK") }}
        </v-btn>
        <v-btn
            text
            to="/privacy"
        >
          {{ $t("PRIVACY_LINK") }}
        </v-btn>
        <v-btn
            text
            to="/tos"
        >
          {{ $t("TERMS_CONDITIONS_SHORTNAME") }}
        </v-btn>
      </v-row>
    </v-col>
    <v-col class="paymentMethods" cols="12" md="6" sm="12">
      <div class="paymentText">
        <div v-if="paymentMethodActive('KLARNA_LATER')">
          <v-icon>check_circle_outline</v-icon>
          <span>{{ $t('FOOTER_PAY_PER_BILL') }}</span>
        </div>
        <div v-if="paymentMethodActive('BANK_TRANSFER')">
          <v-icon>check_circle_outline</v-icon>
          <span>{{ $t('FOOTER_PAY_PER_BANK_TRANSFER') }}</span>
        </div>
        <div v-if="paymentMethodActive('CASH_ENVELOPE')">
          <v-icon>check_circle_outline</v-icon>
          <span>{{ $t('FOOTER_PAY_PER_CASH_ENVELOPE') }}</span>
        </div>
      </div>
      <div class="icons">
        <img v-if="paymentMethodActive('SOFORT')" class="paymentIcon sofort" src="@/assets/payment/sofort.svg">
        <img v-if="paymentMethodActive('CREDIT_CARD')" class="paymentIcon visa" src="@/assets/payment/visa.svg">
        <img v-if="paymentMethodActive('CREDIT_CARD')" class="paymentIcon" src="@/assets/payment/mastercard.svg">
        <img v-if="paymentMethodActive('CREDIT_CARD')" class="paymentIcon" src="@/assets/payment/amex.svg">
        <v-icon v-if="paymentMethodActive('BANK_TRANSFER')" class="paymentIcon" size="30px">account_balance</v-icon>
        <v-icon v-if="paymentMethodActive('CASH_ENVELOPE')" class="paymentIcon" size="30px">mail</v-icon>
      </div>
    </v-col>
    <v-col
        class="footerSupport"
        cols="12"
        md="3"
        primary
        py-3 text-xs-center
        white--text
    >
      <div class="copyright" v-html="$t('FOOTER_COPYRIGHT_NOTICE')"></div>
      <HelpBubble/>
    </v-col>
  </v-row>
</v-footer>

